import Component from '../classes/component';

const SELECTORS = {
  videoController: '.video-controller',
};

class VideoController extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  protected _videoPlayerId: string;

  private _videoPlayer: globalThis.HTMLVideoElement;

  public handleClick() {
    if(this._videoPlayer.paused) this.play();
    else this.pause();
    this.container.classList.toggle('paused');
  }

  public pause() {
    this._videoPlayer.pause();
  }

  public play() {
    this._videoPlayer.play();
  }

  protected _onEnter() {
    this._videoPlayerId = this.container.dataset.videoId;
    this._videoPlayer = document.querySelector<HTMLVideoElement>(`#${this._videoPlayerId}`);
    this._addListener(this.container, 'click', this.handleClick);
  }
}

export default VideoController;
